import { Laptop, Printer, FileLock2, ShoppingCart, ShieldCheck, Tag, Headset, Copy, ScanLine, Lock, Trash2, BadgeCheck } from "lucide-react";
import { Reveal, SectionHeading, waLink } from "./shared";

const CARDS = [
  {
    icon: Laptop,
    title: "Refurbished Laptops",
    headline: "Starting at S$300+",
    desc: "Top brands, great prices. High quality, great value — smart choice, smarter price. Ready to go.",
    points: [
      { icon: ShieldCheck, text: "Tested & certified" },
      { icon: BadgeCheck, text: "Quality guaranteed" },
      { icon: Tag, text: "Affordable prices" },
      { icon: Headset, text: "Warranty & support" },
    ],
    img: "/assets/collateral-refurb.jpg",
    cta: "Ask Current Stock",
    msg: "Hi AFZ Tech Solution, I'm interested in a refurbished laptop (from S$300+). What models are in stock?",
    testid: "refurbished-laptops",
  },
  {
    icon: Printer,
    title: "Printing Services",
    headline: "Print · Copy · Scan",
    desc: "Fast, quality, affordable printing for home and business — documents, flyers, name cards and more.",
    points: [
      { icon: Printer, text: "Print" },
      { icon: Copy, text: "Copy" },
      { icon: ScanLine, text: "Scan" },
    ],
    cta: "Request Printing",
    msg: "Hi AFZ Tech Solution, I need printing services (print / copy / scan).",
    testid: "printing-services",
  },
  {
    icon: FileLock2,
    title: "Document Shredding",
    headline: "Shred · Destroy · Protect",
    desc: "Keep your information safe & secure. Confidential disposal of sensitive documents, done professionally and responsibly.",
    points: [
      { icon: Lock, text: "Secure & confidential" },
      { icon: Trash2, text: "100% private & safe" },
      { icon: BadgeCheck, text: "Professional & reliable" },
    ],
    cta: "Book Shredding",
    msg: "Hi AFZ Tech Solution, I need secure document shredding services.",
    testid: "document-shredding",
  },
];

export const Extras = () => (
  <section id="extras" data-testid="extras-section" className="relative py-24 sm:py-32 bg-navy/40 overflow-hidden">
    <div className="absolute bottom-0 -right-32 w-[26rem] h-[26rem] rounded-full bg-brand-lime/8 blur-[140px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="More From AFZ"
        title="One stop."
        accent="Complete IT solutions."
        sub="Beyond repairs — certified refurbished laptops, business printing and confidential document shredding at the Kembangan workshop."
      />
      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.1}>
            <div
              data-testid={`extras-card-${c.testid}`}
              className="group h-full bg-card/80 border border-slate-800 rounded-2xl overflow-hidden hover:border-brand-lime/50 transition-all duration-300 hover:shadow-[0_0_35px_rgba(170,255,0,0.12)] hover:-translate-y-1 flex flex-col"
            >
              {c.img && (
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent" />
                </div>
              )}
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full border-2 border-brand-lime/60 bg-brand-lime/10 flex items-center justify-center text-brand-lime shadow-[0_0_16px_rgba(170,255,0,0.25)]">
                    <c.icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display text-2xl font-bold uppercase text-white leading-none">{c.title}</h3>
                </div>
                <p className="mt-4 font-display text-lg font-bold uppercase text-brand-lime tracking-wide">{c.headline}</p>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{c.desc}</p>
                <div className="mt-5 grid grid-cols-2 gap-2.5">
                  {c.points.map((p) => (
                    <div key={p.text} className="flex items-center gap-2">
                      <p.icon className="w-4 h-4 text-brand-cyan shrink-0" />
                      <span className="text-xs text-slate-300">{p.text}</span>
                    </div>
                  ))}
                </div>
                <a
                  data-testid={`extras-cta-${c.testid}`}
                  href={waLink(c.msg)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center justify-center gap-2 border border-brand-lime/50 text-brand-lime font-display font-bold uppercase text-xs sm:text-sm tracking-wide px-4 py-2.5 sm:px-5 sm:py-3 rounded-full hover:bg-brand-lime hover:text-void transition-all duration-300 mt-auto"
                >
                  <ShoppingCart className="w-4 h-4 shrink-0" /> {c.cta}
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
